// import { environment } from 'src/environments/environment.prod'
import { environment } from 'src/environments/environment';

export class Constants {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBCgKCAQEAwtic833a683Z04M7fk10wBzX3OmVkI9zSyFfJK2D8k5gal4Z7QTR
  L/6XhPWcBqImacE6ZTniYmKv29MLevQ6abV0oalckfr8ssquD+prrY2uZLzcWw8G
  tuHQAxRMes1LVVA49LdpofeoaM6fIH4XM73BrzqtOrzxFDNfKcqKktjG42IuX8nj
  eyolgRL4ZWjjXUudkwqejmrx5cN+SzdXP4UNuGAo+9iRWM1WAvECAYxj25ecKk1V
  j5uL3+/YCZlV0ISnyj4JVLyaO82dTAUudt1BRjvKE8D7k6jl5OWyFY2jRSntA9Cg
  /nLCsbnmKjbuk4GvQhJNC+Ig30e7Reg+mQIDAQAB
  -----END PUBLIC KEY-----`;
  resetURL = "/#/resetpassword";
  loginURL = "/#/";
  emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  pwdRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
  httpBaseUrl: string = environment.baseUrl;
  httpSurveySharingUrl: string = environment.surveyUrl;
  surveyController: string = "Survey/";
  measureController: string = this.httpBaseUrl + "Measure/";
  accountController: string = "Accounts/";
  loginController: string = "Auth/";
  getFavCards: string = "/favcards"; //dummy
  getAllCards: string = "/mycards"; //dummy
  getValidations: string = "Validation/";
  surveyViewController: string = "Survey";
  NotificationViewController: string = "Notification";


  existingAnonymousResponse: string = "GetExistingAnonymousResponse/"
  surveyResponseController: string = this.httpBaseUrl + "SurveyResponse/";
  surveyResultController: string = this.httpBaseUrl + "SurveyResult/";
  surveyExportController: string = this.httpBaseUrl + "SurveyExport/";
  validationController: string = this.httpBaseUrl + "validation/";
  userManagementController: string = this.httpBaseUrl + "UserManagment/";
  reportManagementController: string = this.httpBaseUrl + "Report/";

  validationdelController: string = this.httpBaseUrl + "Validation";
  errorLogController: string = this.httpBaseUrl + "ErrorLog/";
  entityMasterController: string = this.httpBaseUrl + "EntityMaster/";
  businessProcessController: string = this.httpBaseUrl + "BusinessProcess/"

  incidentReportController: string = this.httpBaseUrl + "IncidentReport/";
  //cognitoController: string = this.httpBaseUrl + "Cognito/"
  generateReportController: string = this.httpBaseUrl + "GenerateReports/"
  kpiController: string = this.httpBaseUrl + "Kpi/"
  customAttributeController: string = this.httpBaseUrl + "CustomAttribute";

  resourceController: string = this.httpBaseUrl + "Resource";
  disputeController: string = this.httpBaseUrl + "Dispute/";
  disputeConfigController: string = this.httpBaseUrl + "DisputeConfig/";
  fileUploadController: string = this.httpBaseUrl + "FileUpload/";

  


  /*Survey URLs*/
  getValidationData: string = this.httpBaseUrl + this.getValidations + "GetValidationDetails";
  getDashboardByGroup: string = this.httpBaseUrl + this.surveyController + "GetDashboardByGroup";
  getUserDashboard: string = this.httpBaseUrl + this.surveyController + "GetDashboard";
  getWorkflow: string = this.httpBaseUrl + this.surveyController + "GetWorkflow";
  saveWorkflow: string = this.httpBaseUrl + this.surveyController + "SaveWorkflow";
  getPerformanceMeasures : string = this.surveyController + "GetPerformanceMeasures"; 
  getMeasureRequirements : string = this.measureController + "GetTierRequirements";
  getPerformanceMeasuresByAgencyId : string = this.surveyController + "GetPerformanceMeasuresByAgencyId"; 

  getTemplateData: string = this.httpBaseUrl + this.surveyController + "GetTemplateData";
  getTemplateDataByGroup: string = this.httpBaseUrl + this.surveyController + "GetTemplateDataByGroup";
  getSurveyUsers: string = `${this.httpBaseUrl}${this.surveyController}GetSurveyUsers`;
  createSurvey: string = this.httpBaseUrl + this.surveyController + "CreateSurvey";
  updateSurvey: string = this.httpBaseUrl + this.surveyController + "UpdateSurvey";
  archiveSurvey: string = this.httpBaseUrl + this.surveyController + "ArchiveSurvey";
  restoreSurvey: string = this.httpBaseUrl + this.surveyController + "RestoreSurvey";
  removeTemplate: string = this.httpBaseUrl + this.surveyController + "RemoveTemplate";
  uploadSurveyImage: string = this.httpBaseUrl + this.surveyController + "UploadSurveyImage";
  setFavoriteSurvey: string = this.httpBaseUrl + this.surveyController + "SetFavouriteSurvey";
  getSurveyAnalysis: string = this.httpBaseUrl + this.surveyViewController + "/GetSurveyAnalytics";
  UpdateSurveySetting: string = this.httpBaseUrl + this.surveyController + "UpdateSurveySetting";
  GetSurveySettings: string = this.httpBaseUrl + this.surveyController + "GetSurveySettings";
  getMultipleResponse: string = this.httpBaseUrl + this.surveyController + "GetMultipleSurveyResponse";
  setMultipleResponse: string = this.httpBaseUrl + this.surveyController + "SetMultipleSurveyResponse";
  accountRegistration: string = this.httpBaseUrl + this.accountController+"Accounts";
  postlogin: string = this.httpBaseUrl + this.loginController + "login";
  getSurveyById: string = this.httpBaseUrl+ this.surveyViewController;
  getNotificationSurveyById: string = this.httpBaseUrl + this.NotificationViewController + "/GetSurveyNotification";
  SaveSurveyNotificationSetting: string = this.httpBaseUrl + this.NotificationViewController + "/SaveSurveyNotificationSetting";
  forgotPassword: string = this.httpBaseUrl + this.loginController + "forgotPassword";
  oldPassword: string = this.httpBaseUrl + this.loginController + "oldPassword";
  refreshToken: string = this.httpBaseUrl + this.loginController + "refresh";
  resetPassword: string = this.httpBaseUrl + this.loginController + "resetPassword";

  postquestions: string = this.httpBaseUrl + this.surveyController + "PostQuestions";
  saveRespondents: string = this.getSurveyById + '/SaveRespondents';
  saveWorkflowRespondent: string = this.httpBaseUrl + this.surveyController + 'SaveWorkflowRespondent';
  shareTemplate: string = this.getSurveyById + '/ShareTemplate'
  savecolorscheme: string = this.httpBaseUrl + this.surveyController + "SaveSurveyTemplateColor";
  craetetemplate: string = this.httpBaseUrl + this.surveyController + "SaveSurveyAsTemplate";
  copySurvey: string = this.httpBaseUrl + this.surveyController + "CopySurvey";
  getpopularData: string = this.httpBaseUrl + this.surveyController + "GetTopFavouriteSurvey";
  getSurveyDueDateByUserGrp: string = this.httpBaseUrl + this.surveyController + "GetSurveyDueDateByUserGroup";
  getSurveyBannerDetails: string = this.httpBaseUrl + this.surveyController + "GetSurveyBannerDetails";
  getSurveyDueAndStartDate: string = this.httpBaseUrl + this.surveyController + "GetSurveyDueAndStartDate";

  getWfBySurveyId: string = this.httpBaseUrl + this.surveyViewController + "/GetWorkflow";

  getWfStepAccessibleBySurveyId: string = this.httpBaseUrl + this.surveyViewController + "/GetWorkflowStepsAssigned";
  ViewWFStatus: string = this.httpBaseUrl + this.surveyViewController + "/ViewWFStatus";
  getLandingScreenPendingSurveys: string = this.httpBaseUrl + this.surveyViewController + "/GetLandingScreenPendingSurveys";
  getLandingScreenDueDateSurveys: string = this.httpBaseUrl + this.surveyViewController + "/GetLandingScreenDueDateSurveys";

  /* Validation Settings URLs*/

  getAllValidations: string = this.validationController + "GetValidationDetails";
  createValidation: string = this.validationController + "CreateValidation";
  updateValidation: string = this.validationController + "UpdateValidation";
  deleteValidation: string = this.validationdelController + "/DeleteValidation";
  getConditioanalOperator: string = this.validationdelController + "/GetConditionalOperators";

  /* User Management URLs*/
  getAllUsersByOrg: string = this.userManagementController + "GetCustomers";
  getAllUsersGroupRole: string = this.userManagementController + "GetUserGroupRole";
  getAllGroups: string = this.userManagementController;
  getAllOrgs: string = this.userManagementController + "GetOrganizations";
  getAllOrgsdet: string = this.userManagementController + "GetAllOrganizations";
  getReportDet: string = this.reportManagementController + "GetReportData";

  getAllGrpByOrg: string = this.userManagementController + "GetGroupByUserId";
  createGroup: string = this.userManagementController + "CreateGroup";
  createOrganization: string = this.userManagementController + "CreateOrganization";
  updateOrganization: string = this.userManagementController + "UpdateOrganization";
  deleteOrganization: string = this.userManagementController + "DeleteOrganization";
  updateGroup: string = this.userManagementController;
  deleteGroup: string = this.userManagementController + "DeleteGroup";
  getUser: string = this.userManagementController + "getUser";
  getAllUserRoles: string = this.userManagementController + "GetUserRoles";
  getUserRolesByUserId: string = this.userManagementController + "GetUserRolesByUserId";
  getCurrentUserRoles: string = this.userManagementController + "GetCurrentUserRoles";
  updateUserRole: string = this.userManagementController + "UpdateUserRole";
  updateDefaultUserRole: string = this.userManagementController + "UpdateDefaultUserRole";
  getGroupsByOrgId: string = this.userManagementController + "GetGroupByOrgnizationId";
  updateGroupName: string = this.userManagementController + "UpdateGroupName";
  getOrganizationByGroupId: string = this.userManagementController + "GetOrganizationByGroupId";
  getGroupsByOrganizationId: string = this.userManagementController + "GetGroupByOrgId";
  getSupervisorByOrg: string = this.userManagementController + "GetSupervisorUser";
  /* Survey Response URLs*/
  initiateSurveyResponse: string = this.surveyResponseController + "InitiateSurvey";
  SubmitSurveyResponse: string = this.surveyResponseController + "SubmitSurvey";
  downloadFiles: string = this.surveyResponseController + "DownloadFiles";
  downloadFileAttachmentsAsZip: string = this.incidentReportController + "DownloadFileAttachments";
  getWorkflowStatusHistory = this.surveyResponseController + "GetWorkflowStatusHistory"
  getExistingAnonymousResponse: string = this.surveyResponseController + "GetExistingAnonymousResponse";
  /* Survey Result URLs*/
  getSurveyResponses: string = this.surveyResultController + "GetSurveyResponses";
  invokeGetQuestionAndResponseExportForScheduler: string = this.surveyExportController + "GetQuestionAndResponseExportForScheduler";
  invokeCopyToIdd : string = this.surveyExportController + "CopyDataToIdd"; 
  GetQuestionAndResponseExportForDatSync: string = this.surveyExportController + "GetQuestionAndResponseExportForDatSync";
  SyncDataToIdd : string = this.surveyExportController + "SyncDataToIdd"; 
   downloadSPSS: string = this.surveyResultController + "DownloadResponseAsSPSSAsync";

  
  getSurveyUserData: string = this.surveyResultController + "GetSurveyUserData";
  getSurveyUserResponseData: string = this.surveyResultController + "GetSurveyResponseData";

  /*Log Exception*/
  logException: string = this.errorLogController + "LogException";

  /* User Activities Log */
  getAllUserActivity: string = this.userManagementController + "GetAllUserActivity";
  CreateUserActivityLog: string = this.userManagementController + "CreateUserActivityLog";

  /*Entity Endpoints*/
  getEntitiesByData: string = this.entityMasterController + "GetEntitiesByGroup";
  getEntities: string = this.entityMasterController + "GetEntities";
  getEntityById: string = this.entityMasterController + "GetEntityById";
  getEntityFileds: string = this.entityMasterController + "GetFieldByEntity";
  createEntity: string = this.entityMasterController + "CreateMasterEntity";
  updateEntity: string = this.entityMasterController + "UpdateMasterEntity";
  getAllTypes: string = this.entityMasterController + "GetAllTypes";
  getEntityDeatils: string = this.entityMasterController + "GetEntityDeatils";
  deleteEntityField: string = this.entityMasterController + "DeleteEntityField";
  updateEntityDetails: string = this.entityMasterController + "UpdateEntityDetails";
  getAllProperties: string = this.entityMasterController + "GetAllProperties";
  shareEntityToGroups: string = this.entityMasterController + "ShareEntityToGroups";
  deleteEntityById: string = this.entityMasterController + "DeleteEntity";
  getDashboardEntities: string = this.entityMasterController + "GetDashboardEntities";
  getEntityInstancesByEntityId: string = this.entityMasterController + "GetEntityInstancesByEntityId";
  getEntitiesbyOrg: string = this.entityMasterController + "GetEntitiesByOrg";
  mpEntityInstanceSuper: string = this.entityMasterController + "MapSupervisor";


  /*BusinessProcess Endpoints*/
  createBusinessProcess: string = this.businessProcessController + "CreateBusinessProcess";
  linkEntities: string = this.businessProcessController + "LinkBusinessProcessEntity";
  getBusinessProcessMasterData: string = this.businessProcessController + "GetBusinessProcess";
  getBusinessProcessByGroupID: string = this.businessProcessController + "GetBusinessProcessByGroupID";
  getBusinessProcessByGroupIdInDataEntry: string = this.businessProcessController + "GetBusinessProcessByGroupIdInDataEntry";
  getBusinessProcessByGroup: string = this.businessProcessController + "GetBusinessProcessByGroup";
  shareBusinessProcessToGroups: string = this.businessProcessController + "ShareBusinessProcessToGroups";
  getBusinessProcessById: string = this.businessProcessController + "GetBusinessProcessById";
  updateBusinessProcess: string = this.businessProcessController + "UpdateBusinessProcess";
  getSurveyData: string = this.businessProcessController + "GetSurvey";
  getSectionById: string = this.businessProcessController + "GetSectionById";

  /*Incident Report*/
  getIncidentWorkFlowDeatils: string = this.incidentReportController + "GetIncidentReportDetailsById";
  //getQuestionsForSection :string = this.incidentReportController + "GetQuestionsForSectionById";
  // getIncidentResponses :string = this.incidentReportController + "GetIncidentResponses";
  // getDisplayInfoDetails : string = this.entityMasterController + "GetDisplayInfoDetails";

  getProcessEntities: string = this.businessProcessController + "GetProcessEntities";

  SubmitIncidentResponse: string = this.incidentReportController + "SubmitIncident";
  // Single entry point for both creating a new response and saving/submitting
  // a section of an existing one (replaces the former createIncident + sectionalSaveAndSubmit pair).
  saveAndSubmit: string = this.incidentReportController + "SaveAndSubmit";
  getAgenciesSurveyResponses: string = this.businessProcessController + "GetAgenciesSurveyResponses";

  SyncSurveyAttestationDataToIdd : string = this.surveyExportController + "SyncSurveyAttestationDataToIdd"; 

  getFieldElementData: string = this.businessProcessController + "GetFieldElementData";

  getWFStatusReport: string = this.businessProcessController + "GetWFStatusReport";

  getProcessIncidentResponses: string = this.incidentReportController + "GetProcessIncidentResponses";

  //getProcessWFStepAssigned: string = this.incidentReportController + "getProcessWFStepAssigned";
  getProcessWFStepAssignedNew: string = this.incidentReportController + "getProcessWFStepAssignedNew";
  showCreateInstanceBtnUser: string = this.incidentReportController + "ShowCreateInstanceBtnUser";
  getUserAgencyDetails: string = this.incidentReportController + "GetUserAgencyDetails";
  getMeasureReviewDetails: string = this.measureController + "GetMeasureReviewDetails";
  // Upload attestation or other files directly to S3 via IncidentReport controller
  getBusinessProcessResponseBasedOnCompletion: string = this.businessProcessController + "GetBusinessProcessResponseBasedOnCompletion";
  getBusinessProcessResponseBasedOnDueDate: string = this.businessProcessController + "GetBusinessProcessResponseBasedOnDueDate";

  getEntityInstancesList: string = this.businessProcessController + "GetEntityInstancesByEntityId";
  getSurveyResponsesByInstanceId: string = this.businessProcessController + "GetSurveyResponsesByInstanceId";

  setLookupEntity: string = this.businessProcessController + "SetLookupEntityForBusinesProcess";

  deleteBusinessProcessById: string = this.businessProcessController + "DeleteBusinesProcessById";
  /*Business process Endpoints*/
  surveySSOUrl: string = this.httpBaseUrl + 'Auth/surveysso';
  getDashboardReportData: string = this.businessProcessController + "GetDashboardReportData";
  getAverageResolutionTime: string = this.businessProcessController + "GetAverageResolutionTime";
  getDashboardReportSeverityData: string = this.businessProcessController + "GetDashboardReportSeverityData";
  getReportGeneratingFields: string = this.reportManagementController + "GetReportGeneratingFields";
  getEntityFieldsData: string = this.reportManagementController + "GetEntityFieldsData";
  generateReport: string = this.reportManagementController + "GenerateReport";
  GetAnnualSubmissionSurveyReport: string = this.reportManagementController + "GetAnnualSubmissionSurveyReport";
  getUserGroupRoleByEmail: string = this.userManagementController + "GetUserGroupRoleByEmail";
  updateCognitoUserMapping: string = this.userManagementController + "UpdateCognitoUsermapping";

  getUserGroupMapping: string = this.userManagementController + "GetUserGroupMapping";
  getKPIResponses: string = this.kpiController + "GetKPIResponses";


  /* Custom Attribute Controller */
  getAllAttributes: string = this.customAttributeController + "/Get";
  createAttribute: string = this.customAttributeController + "/CreateOrUpdate";
  deleteAttribute: string = this.customAttributeController + "/Delete";
  getAttributeByCategory: string = this.customAttributeController + "/GetByCategory";

   HasExistingIncident: string = this.incidentReportController + "HasExistingSurveyInstance";
   GetOrCreateUser:string = this.userManagementController + "GetOrCreateUser";

   //resorce upload URLs
    initiateMultipartUploadUrl: string = this.resourceController + "/InitiateMultipartUpload";
    uploadMultipart: string = this.resourceController + "/UploadFileChunks";
    completemultipartUploadUrl: string =this.resourceController + "/CompleteMultipartUpload";
    DownloadResourceByDocumentType: string = this.resourceController + "/DownloadResourceByDocumentType";
    getResourceDocumentTypesUrl: string = this.resourceController + "/GetResourceDocumentTypes";

    /* Dispute Controller */
    saveDisputeData: string = this.disputeController + "SaveDisputeData";
    getDisputeData: string = this.disputeController + "GetDisputeData";
    getAllDisputesByResponseId: string = this.disputeController + "GetAllDisputesByResponseId";
    getSurveyDisputeConfig: string = this.disputeConfigController + "GetSurveyDisputeConfig";
    // Dispute/Resolution download endpoints
    downloadDisputeAttachmentsAsZip: string = this.disputeController + "DownloadDisputeAttachments";

     uploadFileUrl: string = this.fileUploadController + "UploadFile";
      getFileStatusUrl: string = this.fileUploadController + "GetFileStatus";
      getPreSignedDownloadUrl: string = this.fileUploadController + "GeneratePresignUrl";  
      scoConsentPopupTitle: string = "Supports Coordination Organization";
      rsConsentPopupTitle: string = "Residential Services";
      rsPdfHeadingLine1: string = "Office of Developmental Programs";
      rsPdfHeadingLine2: string = "Residential Services Performance-Based Contracting Attestation";
}
